export default {
  title: 'FormationColCheckboxConfig',
  description: 'Adds a checkbox',
  extends: 'FormationColStyledConfig',
  structure: []
}



/** WEBPACK FOOTER **
 ** ./src/docs/formationColCheckboxConfig.js
 **/